import { render, staticRenderFns } from "./DataPermissionSetting.vue?vue&type=template&id=530fe687&scoped=true&"
import script from "./DataPermissionSetting.vue?vue&type=script&lang=js&"
export * from "./DataPermissionSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fe687",
  null
  
)

export default component.exports